export default "__VITE_ASSET__e437c418__"